import React from 'react';
import { Route, IndexRoute } from 'react-router';

import ArticleContainer from 'modules/News/containers/ArticleContainer';
import Article from 'modules/News/components/Article';
import MoreNews from 'modules/News/containers/MoreNews';
import MostReadAll from 'modules/Common/containers/MostReadAll';

import HomeFootballVidiprinter from 'modules/Home/containers/HomeFootballVidiprinter';
import SectionLink from 'modules/Common/components/SectionLink';
import RacingTips from 'modules/Common/containers/RacingTips';
import FootballTips from 'modules/Common/containers/FootballTips';
import HorseRacingNextRaceOff from 'modules/Common/containers/HorseRacingNextRaceOff';

import AdvertWrapper from 'modules/Common/components/AdvertWrapper';
import GptAdvert from 'modules/Common/components/GptAdvert';
import GooglePublisherTag from 'modules/Common/containers/GooglePublisherTag';

import { newsArticleExpander } from 'modules/News/sitemap-helper.js';

const GenericRHSComponents = {
  MostReadAll,
  HomeFootballVidiprinter,
  SectionLink,
  RacingTips,
  FootballTips,
  HorseRacingNextRaceOff,
  AdvertWrapper,
  GptAdvert,
  GooglePublisherTag
}

export const genericRoute = (homeComponent, navComponent, routePath) => (
  <Route path={routePath} subnav={navComponent}>
    <Route component={homeComponent}> {/* layout manager */}
      <IndexRoute sitemap={{}} components={{ MoreNews, ...GenericRHSComponents }}/> {/* layout */}
    </Route>
    <Route path="news/:title/:articleId" component={ArticleContainer}> {/* layout manager */}
      <IndexRoute sitemap={{expand: newsArticleExpander(routePath)}} components={{ Article, ...GenericRHSComponents }}/> {/* layout */}
    </Route>
  </Route>
);

// More sophisticated alternative to the activeClassName property of react-router's <Link> to allow the link to be "active" for several
// alternative URLs, and for some URLs to prevent the link being active if it otherwise would have been.
// 1st arg is the router - destructuring safety is a hack for tests
// 2nd arg is a link spec, with the following properties
//    href: mandatory url. This will normally be the destination URL of the link being tested.
//    isIndex: optional boolean (default false) to denote if the link should only match exactly
//    alternatives: optional array of objects with href and isIndex properties as above. Add to this to highlight the link for urls other than the links destination
//    exceptions: optional array of objects with href and isIndex properties as above. Add to this to prevent the link being highlighted for some urls that would otherwise have matched
// Testing for a match is done by react-router in the same way as<Link>.
export function isLinkActive({isActive = () => false} = {}, {href = '', isIndex = false, alternatives = [], exceptions = []}) {
  // add the link spec to the list of inclusions
  const inclusions = [{href, isIndex}, ...alternatives];

  // check for all possible positive matches
  let linkIsActive = inclusions.reduce((progress, {href, isIndex}) => (progress || isActive(href, isIndex)), false);

  // then check for any exceptions. Will be shortcut is isActive is already false
  linkIsActive = exceptions.reduce((progress, {href, isIndex}) => (progress && !isActive(href, isIndex)), linkIsActive);

  return linkIsActive;
}

export function activeClassName(router, item, activeClassName, staticClassName) {
  const classList = [];
  const linkIsActive = isLinkActive(router, item);

  if (linkIsActive) {
    classList.push(activeClassName);
  }

  if (staticClassName) {
    classList.push(staticClassName);
  }

  return classList.join(" ");
}

export function getPropertyFromRoutes(routes, propertyName) {
  const found = routes.filter(r => r[propertyName]);
  const [{
    [propertyName]: propertyValue
  } = {}] = found;

  return propertyValue;
}



// WEBPACK FOOTER //
// ./utils/routeUtils.js